import { render } from "./ThxCardCreateView.vue?vue&type=template&id=32faf264&scoped=true"
import script from "./ThxCardCreateView.vue?vue&type=script&lang=js"
export * from "./ThxCardCreateView.vue?vue&type=script&lang=js"

import "./ThxCardCreateView.vue?vue&type=style&index=0&id=32faf264&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32faf264"]])

export default __exports__